import { EmojiStyle } from 'emoji-picker-react';

export const CHAT_EMOJI_STYLE = EmojiStyle.NATIVE;
export const CHAT_EMOJI_VERSION = '12.0';

export const PRIVATE_GROUP_CHAT_ID = 'private-group';
export const PRIVATE_GROUP_CHAT_AVATAR_COLOR = '#03A678';
export const CHAT_INPUT_MAX_LENGTH = 1024;

export const QUICK_REACTIONS = [
  { unified: '1f44d', char: '👍' },
  { unified: '2764-fe0f', char: '❤️' },
  { unified: '1f44f', char: '👏' },
  { unified: '1f602', char: '😂' },
  { unified: '1f44e', char: '👎' },
  { unified: '1f622', char: '😢' },
  { unified: '1f620', char: '😠' },
];

export const CHAT_IMAGE_MAX_COUNT = 5;
export const CHAT_MESSAGE_CARD_WIDTH = 250;
export const CHAT_BUBBLE_RECEIVED_BG = '#EFF3F6';
export const CHAT_BUBBLE_LOCAL_BG = '#3F87DE';
export const CHAT_BUBBLE_LOCAL_BG_DARK = '#739CE9';

export const CHAT_LINKIFY_OPTIONS = {
  defaultProtocol: 'https',
  rel: 'noreferrer noopener',
  target: '_blank',
};
export const CHAT_IMAGE_MAX_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB
// Only raster types that render in an <img>. SVG/ico and other formats are
// rejected because they show as blank in the chat thumbnail and lightbox.
export const CHAT_IMAGE_ALLOWED_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/bmp',
];
export const CHAT_IMAGE_ACCEPT = CHAT_IMAGE_ALLOWED_TYPES.join(',');
export const CHAT_IMAGE_UPLOAD_TIMEOUT_MS = 300_000; // 5 min
